export default __webpack_public_path__ + "03a21db.png";